import React from 'react'
import {
    StyledBoldFont,
    StyledSaveSearchVerificationModalText,
    StyledSaveSearchVerificationModalTitle,
    StyledSaveSearchVerificationModalWrapper,
} from './save-search-form.styles'
import { MODAL_MODE } from './save-search-form'
import { PersonalData } from '../../../patterns/saved-searches/save-search'
import { Link } from '@at/design-system-elements'

interface FirstVerifyProps {
    sendVerificationEmail: () => Promise<boolean>
    setMode: (modalMode: MODAL_MODE) => void
    savedSearchPersonalData: PersonalData
}

export const FirstVerify = ({ sendVerificationEmail, setMode, savedSearchPersonalData }: FirstVerifyProps) => {
    const onResendClick = async () => {
        await sendVerificationEmail().catch((error) => console.log(error.message))
        setMode(MODAL_MODE.CHECK_YOUR_INBOX)
    }

    return (
        <StyledSaveSearchVerificationModalWrapper data-testid="saved-search-modal">
            <>
                <StyledSaveSearchVerificationModalTitle as="h3">
                    First, verify your email address
                </StyledSaveSearchVerificationModalTitle>
                <StyledSaveSearchVerificationModalText as="div">
                    <p>
                        It only takes a moment, and it ensures your account is secure. Follow the instructions in the
                        email we have sent to
                    </p>
                    <StyledBoldFont>{savedSearchPersonalData.email}</StyledBoldFont>
                    <p>You might need to check your junk/spam folder just in case!</p>
                </StyledSaveSearchVerificationModalText>
                <StyledSaveSearchVerificationModalTitle as="h3">
                    Can&apos;t find the email?
                </StyledSaveSearchVerificationModalTitle>
                <Link
                    href="/"
                    data-testid="resend-verification"
                    onClick={async (event) => {
                        event.preventDefault()
                        onResendClick()
                    }}
                >
                    Resend verification email
                </Link>
            </>
        </StyledSaveSearchVerificationModalWrapper>
    )
}
